module.exports = __webpack_public_path__ + "static/sample_bimbo_product-664b078d3f29e9a2b87403609de608c7.png";